import { render, staticRenderFns } from "./config-file.vue?vue&type=template&id=06229ce5&scoped=true&"
import script from "./config-file.vue?vue&type=script&lang=js&"
export * from "./config-file.vue?vue&type=script&lang=js&"
import style0 from "./config-file.vue?vue&type=style&index=0&id=06229ce5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06229ce5",
  null
  
)

export default component.exports